import { useContext } from 'react';
import { ExperimentalDesignSystemContext } from '../../contexts/experimental-design-system';

/**
 * Whether experimental design-system *forms* styles are active.
 * Value is supplied by `DesignSystemProvider` (`src/providers/design-system-provider.tsx`),
 * which sources it from the Flagsmith `release-experimental-design-system-forms` flag.
 */
export function useIsExperimentalDesignSystemForms(): boolean {
  return useContext(ExperimentalDesignSystemContext).isExperimentalForms;
}
